<template>
    <div class="ApplyCourseWarp">
        <!-- 列表数据 -->
        <el-table :data="tableData" style="width: 100%" border :header-cell-style="tableHeaderColor">
            <el-table-column prop="trainCode" label="课程编号" width="150" align="center"></el-table-column>
            <el-table-column prop="trainCourse" label="课程名称" align="center"></el-table-column>
            <el-table-column prop="pay" label="培训费用" align="center"></el-table-column>
            <el-table-column label="报名截止时间" align="center">
                <template slot-scope="scope">
                    <div>
                        {{scope.row.deadline|timer}}
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="状态" width="200" fixed="right" align="center">
                <template slot-scope="scope">
                    <div class="text_warp" v-if="scope.row.trainType==1">
                        <div v-if="scope.row.audit=='98'" class="text5">预审通过</div>
                        <!-- <div v-if="scope.row.audit=='1'" class="text3">预审审核中</div> -->
                        <div v-if="scope.row.audit=='1'" class="text3">预审通过</div>
                        <div v-if="scope.row.audit=='198'" class="text4">预审审核失败</div>
                        <div v-if="scope.row.audit=='99'" class="text3">信息审核中</div>
                        <div v-if="scope.row.audit=='100'" class="text5">信息审核通过</div>
                        <div v-if="scope.row.audit=='199'" class="text4">信息审核失败</div>
                        <div v-if="scope.row.audit=='101'" class="text3">文件审核中</div>
                        <div v-if="scope.row.audit=='3'" class="text4">文件审核失败</div>
                        <div v-if="scope.row.audit=='2'" class="text3">待缴费</div>
                        <div v-if="scope.row.audit=='4'" class="text5">报名完成</div>
                        <div v-if="scope.row.audit=='5'" class="text5">已开班</div>
                        <div v-if="scope.row.audit=='6'" class="text5">培训完成</div>
                    </div>
                    <div class="text_warp" v-else>
                        <div class="text3" v-if="scope.row.audit==0">已报名</div>
                        <div class="text3" v-if="scope.row.audit==1">初审合格</div>
                        <div class="text3" v-if="scope.row.audit==2">审核通过</div>
                        <div class="text4" v-if="scope.row.audit==3">审核失败</div>
                        <div class="text5" v-if="scope.row.audit==4">报名完成</div>
                        <div v-if="scope.row.audit=='6'" class="text5">培训完成</div>

                    </div>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="200" fixed="right" align="center">
                <template slot-scope="scope">
                    <div class="handleBox">
                        <div v-if="scope.row.trainType==1">
                            <div v-if="scope.row.audit=='98'" class="handle_warp" @click="applyDetailFn(scope.row)">信息完善</div>
                            <div v-if="scope.row.audit=='1'" class="handle_warp" @click="applyDetailFn(scope.row)">查看</div>
                            <div v-if="scope.row.audit=='198'" class="handle_warp" @click="applyDetailFn(scope.row)">查看</div>
                            <div v-if="scope.row.audit=='99'" class="handle_warp" @click="applyDetailFn(scope.row)">查看</div>
                            <div v-if="scope.row.audit=='100'" class="handle_warp" @click="applyDetailFn(scope.row)">文件上传</div>
                            <div v-if="scope.row.audit=='199'" class="handle_warp" @click="applyDetailFn(scope.row)">查看</div>
                            <div class="handle_warp" @click="applyDetailFn(scope.row)" v-if="scope.row.audit=='101'">查看</div>
                            <div v-if="scope.row.audit=='3'" class="handle_warp" @click="applyDetailFn(scope.row)">查看</div>
                            <div class="handle_warp" v-if="scope.row.audit=='2'" @click="applyDetailFn(scope.row)">查看</div>
                            <div v-if="scope.row.audit=='4'" class="handle_warp" @click="applyDetailFn(scope.row)">查看</div>
                            <div v-if="scope.row.audit=='5'" class="handle_warp" @click="applyDetailFn(scope.row)">查看</div>
                            <div v-if="scope.row.audit=='6'" class="handle_warp" @click="applyDetailFn(scope.row)">查看</div>
                        </div>
                        <div class="handle_warp" @click="applyDetailFn(scope.row)" v-else>查看</div>
                        <div v-if="scope.row.billAudit==0" class="applyBill" @click="applyBillFn(scope.row)">申请开票</div>
                    </div>
                </template>
            </el-table-column>
            <!-- <el-table-column label="操作" width="200" fixed="right" align="center">
                <template slot-scope="scope">
                    <div></div>
                    </template>
            </el-table-column> -->
        </el-table>
        <!-- 分页 -->
        <div class="paging_warp">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-sizes="[10, 15, 20]"
                :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
        </div>
        <!-- 企业报名信息 -->
        <!-- 已完成课程查看 -->
        <FilshCourseModal :isShow.sync="filishVisible" v-if="filishVisible" @filishShowModal='filishShowModal' :currentCourse='currentCourse'
        />
        <!-- 申请开票 -->
        <LeadBillModal v-if="showBill==1" @changeShowBill='changeShowBill' :leartrainData='leartrainData' />
        <LeadGooseBillModal v-if="showBill==2" @changeShowBill='changeShowBill' :leartrainData='leartrainData' />

    </div>
</template>
<script>
import { httpService, srcUrl } from "@/service/httpService";
import FilshCourseModal from './FilshCourseModal'
import LeadBillModal from '../../../LeadBillModal'
import LeadGooseBillModal from '../../../leadgooseComponents/LeadGooseBillModal'
export default {
    components: {
        FilshCourseModal,
        LeadBillModal,
        LeadGooseBillModal
    },
    data() {
        return {
            tableData: [],
            currentPage: 1,
            // 每页显示条数
            pageSize: 10,
            // 总条数
            total: 0,
            filishVisible: false,
            currentCourse: null,
            audit: '',
            leartrainData: null,
            showBill: 0,

        }
    },
    mounted() {
        this.getList()
    },
    methods: {
        // 获取列表
        async  getList() {
            let params = {
                pageSize: this.pageSize,
                pageCurrent: this.currentPage,
            };
            let data = await httpService.getJoinCourse1(params);
            if (data.code == 200) {
                this.tableData = data.result.list
                this.total = data.result.total
            }
        },
        tableHeaderColor() {
            return "background-color:#FAFAFA;color:rgba(0,0,0,0.85);border-bottom:1px solid #FAFAFA;font-weight:900;height:55px";
        },
        // 分页
        async handleSizeChange(val) {
            this.pageSize = val;
            this.getList()
        },
        async handleCurrentChange(val) {
            this.currentPage = val;
            this.getList()
        },
        applyDetailFn(data) {
            this.currentCourse = data
            this.audit = data.audit
            if (data.audit == 6) {
                this.filishVisible = true
            } else {
                if (data.trainType == 1) {
                    this.$router.push(
                        {
                            path: "/account-center/lead-applydetail",
                            query: {
                                id: data.leaderPersonId,
                                // trainCourse: data.trainCourse,
                                // trainCode: data.trainCode,
                                billAudit: data.billAudit
                            },
                        }
                    )
                } else if (data.trainType == 4) {
                    this.$router.push(
                        {
                            path: "/account-center/lead-gooseapplydetail",
                            query: {
                                id: data.leaderPersonId,
                                // trainCourse: data.trainCourse,
                                // trainCode: data.trainCode,
                                billAudit: data.billAudit
                            },
                        }
                    )
                }
                else {
                    this.$router.push({
                        path: "/account-center/course-applydetail",
                        query: {
                            id: data.trainId,
                        },
                    });
                }
            }
        },
        // 查看已完成课程
        seecoursrFn(val) {
            this.currentCourse = val
            this.filishVisible = true
        },
        filishShowModal() {

        },
        applyBillFn(data) {
            if (data.trainType == 1) {
                this.showBill = 1;
            } else {
                this.showBill = 2
            }
            this.leartrainData = data
        },
        changeShowBill(data) {
            if (!data) {
                this.showBill = 0
                this.canScroll()
            }
        },
    },
    filters: {
        timer: (value) => {
            return value.substring(0, 10);
        },
    },
}
</script>
<style lang="less" scoped>
.ApplyCourseWarp {
  .paging_warp {
    text-align: center;
  }
  .handle_warp {
    cursor: pointer;
    color: #0083ff;
  }
  .handleBox {
    display: flex;
    flex-direction: row;
    justify-content: center;
    .applyBill {
      cursor: pointer;
      color: #0083ff;
      margin-left: 20px;
    }
  }
  .text_warp {
    // .text1 {
    // 	color: #0083ff;
    // }
    // .text2 {
    // 	color: #f0cb15;
    // }
    .text3 {
      color: #f0cb15;
    }
    .text4 {
      color: #fa3a3a;
    }
    .text5 {
      color: #52ca9c;
    }
  }
}
</style>


